
// ********************************************************************** Country

export const GET_ALL_PRODUCT = "GET_ALL_PRODUCT"
export const RESET_STATE = 'RESET_STATE'